import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

const DevelopmentUtils = () => {
  if (import.meta.env.PROD) return null;
  return (
    <>
      <ReactQueryDevtools
        initialIsOpen={false}
        buttonPosition='bottom-left'
      />
    </>
  );
};

export default DevelopmentUtils;
